import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RequestPermission } from '../_core/models/request-permission.model';
import { PermissionService } from '../_core/services/permission.service';
import { ProfileService } from '../_core/services/profile.service';
import { UserService } from '../_core/services/user.service';

import { RequestTypePermissions } from './request-list/request-type-permissions.model';
import { RequestPermissionService } from './request-permission.service';
import { RequestService } from './request.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
  standalone: false,
})
export class RequestComponent implements OnInit, OnDestroy {
  user: any;
  userProfile: any;

  operationPermission: RequestPermission;
  clarificationPermission: RequestPermission;
  historyPermission: RequestPermission;
  cpePermission: RequestPermission;
  poPermissions: string[] = [];
  pePermissions: string[] = [];
  permissions: string[] = [];
  requestSubRouting: boolean;

  constructor(
    private readonly profileService: ProfileService,
    private readonly permissionService: PermissionService,
    private readonly userService: UserService,
    private readonly requestPermissionService: RequestPermissionService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly requestService: RequestService
  ) {}

  ngOnInit() {
    this.requestSubRouting = false;

    this.userProfile = this.profileService.getProfile();
    this.requestService.setIsRet(this.userService.isProfileRetailer());

    this.permissions = this.userProfile.permissions;
    if (
      this.router.url.includes('detail') ||
      this.router.url.includes('create') ||
      this.router.url.includes('request-cpe')
    ) {
      this.requestSubRouting = true;
    }

    this.operationPermission = new RequestPermission(
      RequestTypePermissions.getPoPermissions(),
      true,
      false,
      true,
      true,
      true
    );
    this.clarificationPermission = new RequestPermission(
      RequestTypePermissions.getPePermissions(),
      true,
      false,
      true,
      true,
      true
    );
    this.historyPermission = new RequestPermission(
      RequestTypePermissions.getAllRequestPermissions(),
      true,
      false,
      true,
      true,
      true
    );

    if (!this.requestSubRouting) {
      this.requestPermissionService.getPoAndPePermissions().subscribe((permissionData) => {
        this.poPermissions = permissionData[0] || [];
        this.pePermissions = permissionData[1] || [];
      });
    }
  }

  ngOnDestroy() {
    sessionStorage.removeItem('savedFilters');
  }

  isActivated(route, parent) {
    return this.permissionService.canActivateChildRoute(route, parent);
  }

  /**
   * Validates if a request-cpe tab can be displayed
   * @returns true | false
   */
  showRequestCpeTab(): boolean {
    return (
      this.userService.isProfileRetailer() &&
      (this.isActivated('request-cpe', 'request') || this.permissionService.hasUserPermission('information_cpe'))
    );
  }

  hasRequest() {
    return RequestTypePermissions.getAllRequestPermissions().some(
      (value) => this.userService.getUser().userPermissions.indexOf(value) > -1
    );
  }

  hasInformationCPE(): boolean {
    return this.permissionService.hasUserPermission('information_cpe');
  }

  /**
   * Validates if a request history tab can be displayed
   * @returns true | false
   */
  showRequestHistoryTab(): boolean {
    return this.userService.isProfileRetailer();
  }

  get isRet(): boolean {
    return this.requestService.getIsRet();
  }

  get isDetail(): boolean {
    return this.router.url.includes('detail') ? true : false;
  }
}
